import React, { useEffect, useState } from "react";
import "../../src/main.css";
import useTicketStatsStore from "modules/my_tickets/stats/store.js";
import StatsDateFilter from "modules/my_tickets/stats/statsDateFilter";
import StatsInputData from "modules/my_tickets/stats/StatsInputData";
import ChartsOptions from "modules/my_tickets/stats/StasGraph";
import {
  getFormattedStartDate,
  getFormattedEndDate,
  formatDate,
  getFormattedMinusDate,
} from "functionCall";
import CardDiv from "modules/common/card-div/CardDiv";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

function Stats({ tab }) {
  const { statsData, statsLoading, fetchStatsData, fetchAssignedStatsData } =
    useTicketStatsStore();
  const [statsParams, setStatsQueryParams] = useState("");
  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [selectedPriority, setSelectedPriority] = useState(null);
  const startDate = getFormattedStartDate();
  const endDate = getFormattedEndDate(7);
  const startTicketDate = formatDate(endDate);
  const endTicketDate = getFormattedMinusDate(startDate);
  const [chartType, setChartType] = useState("bar");

  useEffect(() => {
    if (tab === "stats") {
      if (
        startDateFilter?.length < 20 ||
        endDateFilter?.length < 20 ||
        startDateFilter == "" ||
        endDateFilter == ""
      ) {
        fetchStatsData(startTicketDate, endTicketDate);
      } else if (startDateFilter && endDateFilter) {
        fetchStatsData(startDateFilter, endDateFilter);
      }
    }
  }, [
    fetchStatsData,
    startDateFilter,
    endDateFilter,
    startTicketDate,
    endTicketDate,
    tab,
  ]);

  useEffect(() => {
    if (tab ==="stats") {
      if (statsParams !== "") {
        if (startDateFilter && endDateFilter) {
          fetchAssignedStatsData(startDateFilter, endDateFilter, statsParams);
        } else {
          fetchAssignedStatsData(startTicketDate, endTicketDate, statsParams);
        }
      } else {
        if (startDateFilter && endDateFilter) {
          fetchStatsData(startTicketDate, endTicketDate);
        } else {
          fetchStatsData(startTicketDate, endTicketDate);
        }
      }
    }
  }, [fetchAssignedStatsData, statsParams, startTicketDate, endTicketDate]);

  const toggleChartType = () => {
    setChartType(chartType === "line" ? "bar" : "line");
  };

  return (
    <div>
      <CardDiv
        title={
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex flex-row">
              <OverlayTrigger
                overlay={
                  <Tooltip
                    style={{ position: "fixed" }}
                    id="overlay-trigger-example"
                  >
                    {chartType == "bar" ? (
                      <span className="fw-bold">
                        Click to switch Line graph
                      </span>
                    ) : (
                      <span className="fw-bold">Click to switch Bar graph</span>
                    )}
                  </Tooltip>
                }
              >
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={toggleChartType}
                >
                  {chartType === "bar"
                    ? "Switch to Line Graph"
                    : "Switch to Bar Graph"}
                </button>
              </OverlayTrigger>
            </div>
            <div className="item-right d-flex flex-row gap-2 align-self-end">
              <StatsInputData
                setStartDateFilter={setStartDateFilter}
                setEndDateFilter={setEndDateFilter}
                downloadStatsData={statsData}
              />
              <div className="mt-1">
                <StatsDateFilter
                  setStatsQueryParams={setStatsQueryParams}
                  selectedCategory={selectedCategory}
                  selectedSubCategory={selectedSubCategory}
                  selectedPriority={selectedPriority}
                  selectedStatus={selectedStatus}
                  setSelectedCategory={setSelectedCategory}
                  setSelectedSubCategory={setSelectedSubCategory}
                  setSelectedPriority={setSelectedPriority}
                  setSelectedStatus={setSelectedStatus}
                />
              </div>
            </div>
          </div>
        }
        component={
          <ChartsOptions
            data={statsData.data}
            loading={statsLoading}
            chartType={chartType}
          />
        }
      />
    </div>
  );
}

export default Stats;
